// extracted by mini-css-extract-plugin
export default {"image":"style_image__GIl9j","skeleton":"style_skeleton__r9EZ-","shimmer":"style_shimmer__HUdLd"};